import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { ClassroomInfo } from "../classroom/classroomSlice";
import { studentDelete } from "./studentInsUpdSlice";

export interface StudentClassroomsState {
  state: LoadStateInfo;
  studentId?: string;
  schoolId?: string;
  list?: ClassroomInfo[];
}

const initialState: StudentClassroomsState = {
  state: notStarted(),
};

export interface RetrieveStudentClassroomsRequest {
  studentId?: string;
  schoolId?: string;
}
export const retrieveStudentClassrooms = createAsyncThunk(
  "retrieveStudentClassrooms",
  async (params: RetrieveStudentClassroomsRequest, thunkAPI) => {
    console.debug(`retrieve classrooms for student ${params.studentId} at school ${params.schoolId}`);

    const response = await fetch(`${getBackendUrl()}/api/student/${params.studentId}/school/${params.schoolId}/classroom`, {
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
      }
    });

    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);


export const studentClassroomsSlice = createSlice({
  name: "studentClassrooms",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clean: (state) => {
      state.state = notStarted();
      state.list = undefined;
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(retrieveStudentClassrooms.pending, (state, action) => {
        state.state =  loading();
        state.list = undefined;
        state.schoolId = action.meta.arg.schoolId;
        state.studentId = action.meta.arg.studentId;
      })
      .addCase(retrieveStudentClassrooms.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
        state.list = action.payload;
        state.list?.sort((a, b) => (a?.name || "").localeCompare(b?.name || ""));
      })
      .addCase(retrieveStudentClassrooms.rejected, (state, action) => {
        state.state = error(action);
      })
      .addCase(studentDelete.fulfilled, (state, /* action */) => {
        state.state = notStarted();
      })
      ;
    },
});

// export const { } = studentClassroomsSlice.actions;

export const selectStudentClassrooms = (state: RootState) => state.studentClassrooms;

export default studentClassroomsSlice.reducer;
